import React, { useContext } from 'react';
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { Link } from "wouter";

import quizInstanceAdminStatusContext from '../context/quizInstanceAdminStatusContext';
import QuizAdminLobbyTimer from './QuizAdminLobbyTimer';
import { absURL } from '../utils';
import QuizAdminStartBtn from './QuizAdminStartBtn';
import QuizAdminEndBtn from './QuizAdminEndBtn';
import QuizAdminRoomMode from './QuizAdminRoomMode';

export default function QuizAdminInProgress() {

  const ctx = useContext(quizInstanceAdminStatusContext);

  if (ctx.quizInfo.config?.standingMode) {
    return (
      <div id="quizAdminLobby">
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className="text-center w-50">
            <h3>Stående instans &mdash; samlar in svar</h3>
            <p className="mt-2">
              {ctx.quizInfo.participantAnsweredCount || 0} av {ctx.quizInfo.participantTotalCount || 0} har svarat hittills
            </p>
            <div className="mt-3">
              <QuizAdminEndBtn />
            </div>
            <div className="mt-4">
              <div className="d-inline overflow-hidden mt-1 px-2 quizUrlPill">
                <a target="_blank" rel="noreferrer" className="text-quizPrimaryBold" href={ctx.quizUrl}>{ctx.quizUrl}</a>
              </div>
              {ctx.quizUrlQrCode && <div className="mt-4">
                <img style={{width: "250px"}} src={ctx.quizUrlQrCode} alt="" />
              </div>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (ctx.quizInfo.config?.roomMode) {
    return <QuizAdminRoomMode />;
  }
	// Participants in an active kurstillfälle already joined at the start of
	// the day and get pushed in automatically — a join code/link/QR here has
	// no purpose for them and is just noise.
	let authInfo;
	if (!ctx.isCourseSession) {
		switch(ctx.quizInfo.auth.type)
		{
			default:
			case "Passcode":
				authInfo = <h1>Kod: {ctx.quizInfo.auth.json.passcode}</h1>;
			break;
		}
	}

	return (
		<div id="quizAdminLobby">
			<div className="d-flex justify-content-center align-items-center h-100">
				<div className="text-center w-50">
					<div>{authInfo}</div>
					<QuizAdminLobbyTimer 
            startedAt={ctx.quizInfo.startedAt} 
            endsAt={ctx.quizInfo.endsAt} 
          />
					<div className="">
						<div className="mt-3">
							<QuizAdminStartBtn />
						</div>
						<Link href={absURL(`/${ctx.quizAccessShortId}/result`)}>
							<Button type="submit" className="mt-3 ml-3" variant="quizPrimary">
								<FontAwesomeIcon icon={faChevronRight} className="mr-2" />
								Till resultatsidan
							</Button>
						</Link>
						<div className="mt-3">
							<QuizAdminEndBtn />
						</div>
					</div>
					{!ctx.isCourseSession && (
						<div className="mt-4">
							<div className="d-inline overflow-hidden mt-1 px-2 quizUrlPill">
								<a target="_blank" rel="noreferrer" className="text-quizPrimaryBold" href={ctx.quizUrl}>{ctx.quizUrl}</a>
							</div>
							{ctx.quizUrlQrCode && <div className="mt-4">
								<img style={{width: "250px"}} src={ctx.quizUrlQrCode} alt="" />
							</div>}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};